import React from 'react';

const AMAC_STIL = {
  'Farkındalık': 'bg-red-50 text-red-700 border-red-200',
  'Etkileşim': 'bg-pink-50 text-pink-700 border-pink-200',
  'Trafik': 'bg-sky-50 text-sky-700 border-sky-200',
  'Dönüşüm': 'bg-emerald-50 text-emerald-700 border-emerald-200',
  'Mesaj / DM': 'bg-violet-50 text-violet-700 border-violet-200',
};

function Amac({ tip, not }) {
  return (
    <span className={`inline-flex items-center px-2 py-0.5 rounded-md border text-[11px] font-medium whitespace-nowrap ${AMAC_STIL[tip] || 'bg-gray-50 text-gray-700 border-gray-200'}`}>
      {tip}{not ? ` (${not})` : ''}
    </span>
  );
}

export default function KixxAgustos2026() {
  return (
    <div className="p-6 max-w-7xl mx-auto space-y-16">

      {/* ═══════════════════════════════════════════════════════════════════════ */}
      {/* KIXX — ₺70,000 — Ağustos 2026                                          */}
      {/* Meta ₺41,000 + Google ₺27,000 (Search 20K + YouTube 7K) + TikTok ₺2,000 */}
      {/* Meta birim maliyetleri Temmuz 2026 GERÇEKLEŞEN veriden türetildi        */}
      {/* ═══════════════════════════════════════════════════════════════════════ */}
      <div className="bg-white rounded-2xl shadow-sm border overflow-hidden">
        <div className="bg-white border-b p-5 flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
          <div className="flex items-center gap-4">
            <div className="rounded-lg bg-gray-900 px-3 py-2">
              <img src="/kixx/img/kixx-logo-white.png" alt="KIXX" className="h-7 w-auto object-contain" />
            </div>
            <div className="ml-1">
              <h2 className="text-lg font-bold text-gray-800">KIXX — Ağustos 2026 Medya Planı</h2>
              <p className="text-sm text-gray-500">3 Hedef Kitle • Kadın · Wellness (Dark) · Erkek • Meta (Lead + Engagement) • Google (Search + YouTube) • TikTok (Video Views)</p>
            </div>
          </div>
          <div className="flex items-center gap-3">
            <span className="inline-flex items-center px-3 py-1 bg-gray-100 text-gray-600 text-xs font-medium rounded-full border border-gray-200">
              Ağustos 2026
            </span>
            <span className="inline-flex items-center px-3 py-1.5 bg-gray-800 text-white text-sm font-semibold rounded-full">
              Total: ₺70,000
            </span>
          </div>
        </div>

        <div className="p-6">
          {/* Kampanya Odağı */}
          <div className="mb-6 p-4 rounded-xl bg-cyan-50 border border-cyan-200">
            <p className="text-xs font-semibold text-cyan-800 mb-1">Ağustos Odağı — Sezon Öncesi Üyelik Toplama + Video Kanallarının Açılması</p>
            <p className="text-[11px] text-cyan-700 leading-relaxed">
              Ağustos, spor salonu kategorisinde <strong>Eylül yoğunluğunun hazırlık ayıdır</strong>: tatil dönüşü ve yeni sezon niyetiyle
              üyelik araştırması ay ortasından itibaren hızlanır. Kurgu, Haziran'da oturan <strong>3 hedef kitle yapısını</strong> (Kadın ·
              Wellness Dark · Erkek) koruyor; her kitlede <strong>Lead</strong> ve <strong>Engagement</strong> kampanyası çalışıyor; ancak bu ay iletişim yalnızca Meta'da kalmıyor —
              <strong> YouTube ve TikTok video kanalları devreye alınıyor</strong>. Bunların bütçesi Meta'dan aktarıldı: Meta ₺50K'dan
              <strong> ₺41K</strong>'ya çekildi, açılan ₺9K'nın <strong>₺7K'sı YouTube</strong>'a, <strong>₺2K'sı TikTok</strong>'a verildi.
              TikTok bu ay bilinçli olarak <strong>test bütçesiyle</strong> açılıyor: kanalın bu kitlede çalışıp çalışmadığını ölçmek için yeterli, ana bütçeyi lead'den çalmayacak kadar küçük.
            </p>
          </div>

          {/* Temmuz gerçekleşen → Ağustos plan */}
          <div className="mb-6 rounded-xl border border-slate-200 overflow-hidden">
            <div className="bg-slate-100 px-4 py-2.5 text-xs font-semibold text-gray-800">Temmuz 2026 Gerçekleşen → Ağustos 2026 Plan</div>
            <div className="overflow-x-auto">
              <table className="min-w-full text-[11px]">
                <thead className="bg-gray-50 text-gray-500">
                  <tr>
                    <th className="px-4 py-2 text-left font-medium uppercase tracking-wider">Mecra</th>
                    <th className="px-4 py-2 text-right font-medium uppercase tracking-wider">Temmuz Harcama</th>
                    <th className="px-4 py-2 text-right font-medium uppercase tracking-wider">Temmuz CPC</th>
                    <th className="px-4 py-2 text-right font-medium uppercase tracking-wider">Temmuz CPM</th>
                    <th className="px-4 py-2 text-right font-medium uppercase tracking-wider">Ağustos Plan</th>
                    <th className="px-4 py-2 text-right font-medium uppercase tracking-wider">Değişim</th>
                  </tr>
                </thead>
                <tbody className="bg-white divide-y divide-gray-100 text-gray-700">
                  <tr>
                    <td className="px-4 py-2 font-medium">Meta Ads</td>
                    <td className="px-4 py-2 text-right">₺70,981</td>
                    <td className="px-4 py-2 text-right">₺5.47</td>
                    <td className="px-4 py-2 text-right">₺121</td>
                    <td className="px-4 py-2 text-right font-semibold">₺41,000</td>
                    <td className="px-4 py-2 text-right text-rose-600">-42%</td>
                  </tr>
                  <tr>
                    <td className="px-4 py-2 font-medium">Google Ads (Search + YouTube)</td>
                    <td className="px-4 py-2 text-right text-rose-600">₺0 — hesapta hiç harcama yok</td>
                    <td className="px-4 py-2 text-right text-gray-400">-</td>
                    <td className="px-4 py-2 text-right text-gray-400">-</td>
                    <td className="px-4 py-2 text-right font-semibold">₺27,000</td>
                    <td className="px-4 py-2 text-right text-blue-600">yeni</td>
                  </tr>
                  <tr>
                    <td className="px-4 py-2 font-medium">TikTok Ads</td>
                    <td className="px-4 py-2 text-right text-gray-400">₺0 (yayında değil)</td>
                    <td className="px-4 py-2 text-right text-gray-400">-</td>
                    <td className="px-4 py-2 text-right text-gray-400">-</td>
                    <td className="px-4 py-2 text-right font-semibold">₺2,000</td>
                    <td className="px-4 py-2 text-right text-blue-600">yeni (test)</td>
                  </tr>
                  <tr className="bg-gray-50 font-semibold text-gray-800">
                    <td className="px-4 py-2">Toplam</td>
                    <td className="px-4 py-2 text-right">₺70,981</td>
                    <td className="px-4 py-2 text-right">₺5.47</td>
                    <td className="px-4 py-2 text-right">-</td>
                    <td className="px-4 py-2 text-right">₺70,000</td>
                    <td className="px-4 py-2 text-right text-gray-600">≈ aynı</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div className="px-4 py-2.5 bg-rose-50 border-t border-rose-100 text-[11px] text-rose-800">
              <strong>Aksiyon gerektiren not:</strong> Haziran planında ₺20,000 Google Search öngörülmüştü ancak Google Ads hesabında
              <strong> Nisan-Ağustos arasında tek bir harcama kaydı yok</strong> — kampanya hiç yayına alınmamış görünüyor.
              Ağustos'ta Google payı ₺27,000'e çıkıyor (Search + YouTube); bu bütçenin harcanabilmesi için önce hesap ve dönüşüm
              kurulumunun tamamlanması gerekiyor. Kurulum yetişmezse ay ₺43,000 (Meta + TikTok) ile geçer.
            </div>
          </div>

          {/* AMAÇ BAZLI BÜTÇE DAĞILIMI */}
          <div className="rounded-xl border overflow-hidden mb-6">
            <div className="bg-slate-100 px-4 py-3 font-semibold text-gray-800">Kampanya Amacına Göre Bütçe Dağılımı</div>
            <div className="px-4 pt-4">
              <div className="flex w-full h-3 rounded-full overflow-hidden border border-gray-200">
                <div className="bg-emerald-400" style={{ width: '72.9%' }} title="Dönüşüm %73" />
                <div className="bg-pink-400" style={{ width: '14.3%' }} title="Etkileşim %14" />
                <div className="bg-red-400" style={{ width: '12.8%' }} title="Farkındalık %13" />
              </div>
            </div>
            <div className="overflow-x-auto">
              <table className="min-w-full text-[12px] mt-3">
                <thead className="bg-gray-50 text-gray-500">
                  <tr>
                    <th className="px-4 py-2 text-left font-medium uppercase tracking-wider text-[11px]">Amaç</th>
                    <th className="px-4 py-2 text-right font-medium uppercase tracking-wider text-[11px]">Bütçe</th>
                    <th className="px-4 py-2 text-right font-medium uppercase tracking-wider text-[11px]">Pay</th>
                    <th className="px-4 py-2 text-left font-medium uppercase tracking-wider text-[11px]">Ana Mecralar</th>
                    <th className="px-4 py-2 text-left font-medium uppercase tracking-wider text-[11px]">Hedeflenen Çıktı</th>
                  </tr>
                </thead>
                <tbody className="bg-white divide-y divide-gray-100 text-gray-700">
                  <tr>
                    <td className="px-4 py-2.5"><Amac tip="Dönüşüm" not="lead" /></td>
                    <td className="px-4 py-2.5 text-right font-semibold">₺51,000</td>
                    <td className="px-4 py-2.5 text-right">73%</td>
                    <td className="px-4 py-2.5">Meta Lead (3 kitle) · Google Search (Generic + Rakip)</td>
                    <td className="px-4 py-2.5">8,438 lead odaklı tıklama</td>
                  </tr>
                  <tr>
                    <td className="px-4 py-2.5"><Amac tip="Farkındalık" /></td>
                    <td className="px-4 py-2.5 text-right font-semibold">₺9,000</td>
                    <td className="px-4 py-2.5 text-right">13%</td>
                    <td className="px-4 py-2.5">Google YouTube · TikTok Video Views (test)</td>
                    <td className="px-4 py-2.5">91,666 izlenme · 220K gösterim</td>
                  </tr>
                  <tr>
                    <td className="px-4 py-2.5"><Amac tip="Etkileşim" /></td>
                    <td className="px-4 py-2.5 text-right font-semibold">₺10,000</td>
                    <td className="px-4 py-2.5 text-right">14%</td>
                    <td className="px-4 py-2.5">Meta Engagement (3 kitle ayrı)</td>
                    <td className="px-4 py-2.5">21,806 etkileşim</td>
                  </tr>
                  <tr className="bg-gray-50 font-semibold text-gray-800">
                    <td className="px-4 py-2.5">Toplam</td>
                    <td className="px-4 py-2.5 text-right">₺70,000</td>
                    <td className="px-4 py-2.5 text-right">100%</td>
                    <td className="px-4 py-2.5">3 mecra · 10 kampanya</td>
                    <td className="px-4 py-2.5">8,438 tıklama · 21.8K etkileşim · 92K izlenme</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div className="px-4 py-2.5 bg-emerald-50 border-t border-emerald-100 text-[11px] text-emerald-800">
              Üyelik satışı <strong>lead üzerinden</strong> yürüdüğü için ağırlık dönüşümde (%73). Etkileşim ve farkındalık bacağı (%27)
              Eylül'ün pahalı lead dönemine girmeden önce ucuz izlenme ve etkileşim havuzu kurar; bu havuz Eylül'de doğrudan
              retargeting kaynağı olarak lead maliyetini düşürmek için kullanılır.
            </div>
          </div>

          {/* Mecra + Kitle Özeti */}
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4 mb-6">
            <div className="rounded-xl border border-indigo-100 bg-indigo-50 p-4">
              <div className="flex items-center gap-2 mb-1">
                <img src="/6033716.png" alt="Meta" className="w-5 h-5 object-contain" />
                <span className="text-xs font-medium text-indigo-700">Meta Ads</span>
              </div>
              <p className="text-xl font-bold text-indigo-800">₺41,000</p>
              <p className="text-[10px] text-indigo-600 mt-0.5">59% • 3 Kitle × (Lead + Engagement)</p>
            </div>
            <div className="rounded-xl border border-blue-100 bg-blue-50 p-4">
              <div className="flex items-center gap-2 mb-1">
                <img src="/google_ads-512.webp" alt="Google" className="w-5 h-5 object-contain" />
                <span className="text-xs font-medium text-blue-700">Google Ads</span>
              </div>
              <p className="text-xl font-bold text-blue-800">₺27,000</p>
              <p className="text-[10px] text-blue-600 mt-0.5">39% • Generic ₺12K + Rakip ₺8K + YouTube ₺7K</p>
            </div>
            <div className="rounded-xl border border-gray-200 bg-gray-50 p-4">
              <div className="flex items-center gap-2 mb-1">
                <img src="/tiktokv4.svg" alt="TikTok" className="w-5 h-5 object-contain" />
                <span className="text-xs font-medium text-gray-700">TikTok Ads</span>
              </div>
              <p className="text-xl font-bold text-gray-800">₺2,000</p>
              <p className="text-[10px] text-gray-600 mt-0.5">3% • test bütçesi • Video Views</p>
            </div>
            <div className="rounded-xl border border-rose-100 bg-rose-50 p-4">
              <span className="text-xs font-medium text-rose-700">Kitle Bazlı — Meta</span>
              <p className="text-sm font-bold text-rose-800 mt-1">Kadın ₺14K</p>
              <p className="text-[10px] text-rose-600">Wellness ₺16K · Erkek ₺11K</p>
            </div>
            <div className="rounded-xl border border-emerald-100 bg-emerald-50 p-4">
              <span className="text-xs font-medium text-emerald-700">Toplam Tıklama</span>
              <p className="text-xl font-bold text-emerald-800">8.4K</p>
              <p className="text-[10px] text-emerald-600 mt-0.5">Meta 5.6K + Google 2.8K</p>
            </div>
            <div className="rounded-xl border border-red-100 bg-red-50 p-4">
              <span className="text-xs font-medium text-red-700">Toplam İzlenme</span>
              <p className="text-xl font-bold text-red-800">92K</p>
              <p className="text-[10px] text-red-600 mt-0.5">YouTube 58K + TikTok 33K</p>
            </div>
          </div>

          {/* ANA PLAN TABLOSU */}
          <div className="rounded-xl border overflow-hidden mb-8">
            <div className="bg-slate-100 px-4 py-3 font-semibold text-gray-800">Medya Planı — KIXX Ağustos 2026</div>
            <div className="overflow-x-auto">
              <table className="min-w-full divide-y divide-gray-200">
                <thead className="bg-gray-50">
                  <tr>
                    <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Mecra</th>
                    <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Kampanya</th>
                    <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Hedef Kitle</th>
                    <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Amaç</th>
                    <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Tahmini Çıktı</th>
                    <th className="px-4 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">Bütçe</th>
                  </tr>
                </thead>
                <tbody className="bg-white divide-y divide-gray-100 text-[12px] text-gray-700">
                  {/* Meta */}
                  <tr className="hover:bg-gray-50">
                    <td className="px-4 py-3 font-medium align-top" rowSpan={6}>
                      <div className="flex items-center gap-2">
                        <img src="/6033716.png" alt="Meta" className="w-5 h-5 object-contain" />
                        <span>Meta Ads</span>
                      </div>
                    </td>
                    <td className="px-4 py-3">Lead</td>
                    <td className="px-4 py-3"><strong>Kadın</strong> · 22-45 · pilates, reformer, grup dersleri, wellness ilgi alanları</td>
                    <td className="px-4 py-3"><Amac tip="Dönüşüm" not="lead" /></td>
                    <td className="px-4 py-3">91,000 gösterim · 68,000 erişim · 2,037 tıklama · ₺5.4 CPC</td>
                    <td className="px-4 py-3 text-right font-medium">₺11,000</td>
                  </tr>
                  <tr className="hover:bg-gray-50">
                    <td className="px-4 py-3">Engagement</td>
                    <td className="px-4 py-3"><strong>Kadın</strong> · 22-45 + sayfa etkileşimcileri</td>
                    <td className="px-4 py-3"><Amac tip="Etkileşim" /></td>
                    <td className="px-4 py-3">45,000 gösterim · 34,000 erişim · 6,667 etkileşim · ₺0.45 CPE</td>
                    <td className="px-4 py-3 text-right font-medium">₺3,000</td>
                  </tr>
                  <tr className="hover:bg-gray-50">
                    <td className="px-4 py-3">Lead</td>
                    <td className="px-4 py-3"><strong>Wellness</strong> · 25-50, üst gelir · sauna, havuz, spa deneyimi arayanlar (dark kreatif)</td>
                    <td className="px-4 py-3"><Amac tip="Dönüşüm" not="lead" /></td>
                    <td className="px-4 py-3">99,000 gösterim · 74,000 erişim · 2,222 tıklama · ₺5.4 CPC</td>
                    <td className="px-4 py-3 text-right font-medium">₺12,000</td>
                  </tr>
                  <tr className="hover:bg-gray-50">
                    <td className="px-4 py-3">Engagement</td>
                    <td className="px-4 py-3"><strong>Wellness</strong> · 25-50 + video izleyicileri (dark kreatif + wellness post)</td>
                    <td className="px-4 py-3"><Amac tip="Etkileşim" /></td>
                    <td className="px-4 py-3">60,000 gösterim · 45,000 erişim · 8,889 etkileşim · ₺0.45 CPE</td>
                    <td className="px-4 py-3 text-right font-medium">₺4,000</td>
                  </tr>
                  <tr className="hover:bg-gray-50">
                    <td className="px-4 py-3">Lead</td>
                    <td className="px-4 py-3"><strong>Erkek</strong> · 20-45 · fonksiyonel antrenman, power, ağırlık</td>
                    <td className="px-4 py-3"><Amac tip="Dönüşüm" not="lead" /></td>
                    <td className="px-4 py-3">66,000 gösterim · 50,000 erişim · 1,333 tıklama · ₺6.0 CPC</td>
                    <td className="px-4 py-3 text-right font-medium">₺8,000</td>
                  </tr>
                  <tr className="hover:bg-gray-50">
                    <td className="px-4 py-3">Engagement</td>
                    <td className="px-4 py-3"><strong>Erkek</strong> · 20-45 + sayfa etkileşimcileri</td>
                    <td className="px-4 py-3"><Amac tip="Etkileşim" /></td>
                    <td className="px-4 py-3">45,000 gösterim · 34,000 erişim · 6,250 etkileşim · ₺0.48 CPE</td>
                    <td className="px-4 py-3 text-right font-medium">₺3,000</td>
                  </tr>
                  <tr className="bg-indigo-50 font-semibold text-indigo-800">
                    <td className="px-4 py-3" colSpan={4}>Meta Ads Toplam</td>
                    <td className="px-4 py-3">405,000 gösterim · 305,000 brüt erişim · 5,592 tıklama · 21,806 etkileşim</td>
                    <td className="px-4 py-3 text-right">₺41,000</td>
                  </tr>

                  {/* Google */}
                  <tr className="hover:bg-gray-50">
                    <td className="px-4 py-3 font-medium align-top" rowSpan={3}>
                      <div className="flex items-center gap-2">
                        <img src="/google_ads-512.webp" alt="Google Ads" className="w-5 h-5 object-contain" />
                        <span>Google Ads</span>
                      </div>
                    </td>
                    <td className="px-4 py-3">Search — Generic</td>
                    <td className="px-4 py-3">"ataşehir spor salonu", "ataşehir fitness", "spor salonu ataşehir", "ataşehir pilates" arayanlar · kulüp çevresi lokasyon kısıtı</td>
                    <td className="px-4 py-3"><Amac tip="Dönüşüm" not="lead" /></td>
                    <td className="px-4 py-3">26,000 gösterim · 1,846 tıklama · ₺6.5 CPC</td>
                    <td className="px-4 py-3 text-right font-medium">₺12,000</td>
                  </tr>
                  <tr className="hover:bg-gray-50">
                    <td className="px-4 py-3">Search — Rakip</td>
                    <td className="px-4 py-3">Ataşehir ve çevresindeki rakip spor salonu / fitness kulübü marka adlarını arayanlar · lokasyon kısıtlı</td>
                    <td className="px-4 py-3"><Amac tip="Dönüşüm" not="lead" /></td>
                    <td className="px-4 py-3">20,000 gösterim · 1,000 tıklama · ₺8.0 CPC</td>
                    <td className="px-4 py-3 text-right font-medium">₺8,000</td>
                  </tr>
                  <tr className="hover:bg-gray-50">
                    <td className="px-4 py-3">YouTube Video</td>
                    <td className="px-4 py-3">3 kitle ayrı reklam grubu · kulüp çevresi yarıçap · spor/wellness ilgi + rakip kanal yerleşimleri</td>
                    <td className="px-4 py-3"><Amac tip="Farkındalık" /></td>
                    <td className="px-4 py-3">140,000 gösterim · 58,333 izlenme · ₺0.12 CPV</td>
                    <td className="px-4 py-3 text-right font-medium">₺7,000</td>
                  </tr>
                  <tr className="bg-blue-50 font-semibold text-blue-800">
                    <td className="px-4 py-3" colSpan={4}>Google Ads Toplam</td>
                    <td className="px-4 py-3">186,000 gösterim · 2,846 tıklama · 58K izlenme</td>
                    <td className="px-4 py-3 text-right">₺27,000</td>
                  </tr>

                  {/* TikTok */}
                  <tr className="hover:bg-gray-50">
                    <td className="px-4 py-3 font-medium align-top">
                      <div className="flex items-center gap-2">
                        <img src="/tiktokv4.svg" alt="TikTok" className="w-5 h-5 object-contain" />
                        <span>TikTok Ads</span>
                      </div>
                    </td>
                    <td className="px-4 py-3">Video Views</td>
                    <td className="px-4 py-3">20-45 · kulüp çevresi · fitness, wellness, sauna içerik izleyicileri</td>
                    <td className="px-4 py-3"><Amac tip="Farkındalık" /></td>
                    <td className="px-4 py-3">80,000 gösterim · 33,333 izlenme · ₺25 CPM · ₺0.06 CPV</td>
                    <td className="px-4 py-3 text-right font-medium">₺2,000</td>
                  </tr>
                  <tr className="bg-gray-100 font-semibold text-gray-800">
                    <td className="px-4 py-3" colSpan={4}>TikTok Ads Toplam</td>
                    <td className="px-4 py-3">80,000 gösterim · 33K izlenme</td>
                    <td className="px-4 py-3 text-right">₺2,000</td>
                  </tr>

                  {/* Grand Total */}
                  <tr className="bg-gray-800 text-white font-bold">
                    <td className="px-4 py-3" colSpan={4}>GENEL TOPLAM</td>
                    <td className="px-4 py-3">671,000 gösterim · 8,438 tıklama · 21,806 etkileşim · 91,666 izlenme</td>
                    <td className="px-4 py-3 text-right">₺70,000</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          {/* Hedefleme & Strateji */}
          <div className="rounded-xl border overflow-hidden mb-8">
            <div className="bg-slate-100 px-4 py-3 font-semibold text-gray-800">Hedefleme &amp; Strateji — 3 Hedef Kitle</div>
            <div className="p-5 grid grid-cols-1 md:grid-cols-3 gap-4 text-[12px] text-gray-700">
              <div className="rounded-lg border border-rose-100 bg-rose-50/40 p-3">
                <p className="font-semibold text-rose-800 mb-1">Kadın — ₺14,000</p>
                <p className="leading-relaxed">22-45 yaş kadın; pilates / reformer / grup dersleri / wellness ilgi alanları. Ağustos'ta "tatil sonrası forma dönüş" tonu; <strong>Lead</strong> kampanyası. <strong>Engagement</strong> kampanyası Eylül retargeting havuzunu büyütür.</p>
              </div>
              <div className="rounded-lg border border-slate-300 bg-slate-800/5 p-3">
                <p className="font-semibold text-slate-800 mb-1">Wellness &amp; Sauna &amp; Havuz — ₺16,000</p>
                <p className="leading-relaxed">25-50 yaş, üst gelir; sauna + havuz + spa deneyimi. Atmosferik <strong>dark kreatif</strong> ile premium konumlandırma. Yaz sonu sıcaklarında havuz vurgusu öne çıkar; Meta içinde en yüksek pay burada.</p>
              </div>
              <div className="rounded-lg border border-sky-100 bg-sky-50/40 p-3">
                <p className="font-semibold text-sky-800 mb-1">Erkek — ₺11,000</p>
                <p className="leading-relaxed">20-45 yaş erkek; fonksiyonel antrenman / power / ağırlık. Performans odaklı <strong>Lead</strong> kampanyası. Temmuz'da bu kitlenin CPC'si diğerlerinden yüksek seyrettiği için bütçe payı en düşük tutuldu.</p>
              </div>
            </div>
            <div className="px-5 pb-5 grid grid-cols-1 md:grid-cols-2 gap-4 text-[12px] text-gray-700">
              <div>
                <p className="font-semibold text-gray-800 mb-1">Video Kanalları → Retargeting Havuzu</p>
                <p className="leading-relaxed">YouTube ve TikTok'ta toplam <strong>92K izlenme</strong> hedefleniyor. %50+ izleyenler ve etkileşim havuzu, Eylül'ün yoğun üyelik döneminde Meta Lead kampanyalarının <strong>retargeting kaynağı</strong> olur — izlenme başı maliyet, lead tıklaması başına maliyetin ~%2'si. TikTok bu ay yalnızca <strong>₺2K test</strong> ile açık; kanal çalışırsa Eylül'de ölçülmüş birim maliyetle büyütülür.</p>
              </div>
              <div>
                <p className="font-semibold text-gray-800 mb-1">Search — Generic + Rakip</p>
                <p className="leading-relaxed">İki ayrı kampanya: <strong>Generic</strong> ("ataşehir spor salonu" tipi lokasyon + kategori aramaları) ve <strong>Rakip</strong> (çevredeki rakip kulüp marka adları). İkisi de lokasyon kısıtlı ve form dönüşümü odaklı. Rakip kampanyasında kalite skoru düşük olacağı için CPC ₺8.0 ile projekte edildi. <strong>Ön koşul:</strong> hesapta dönüşüm izleme kurulumu — bu tamamlanmadan Search bütçesi harcanamaz.</p>
              </div>
            </div>
          </div>

          {/* Disclaimer */}
          <div className="p-4 rounded-xl bg-amber-50 border border-amber-200">
            <div className="flex items-start gap-2.5">
              <div className="flex-shrink-0 mt-0.5">
                <svg className="w-4 h-4 text-amber-500" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
                </svg>
              </div>
              <div>
                <p className="text-xs font-semibold text-amber-800">Projeksiyon Notu</p>
                <p className="text-[11px] text-amber-700 mt-1 leading-relaxed">
                  Meta tarafındaki birim maliyetler hesabın <strong>Temmuz 2026 gerçekleşen verisinden</strong> alınmıştır
                  (ortalama ₺5.47 CPC · ₺121 CPM; lead kampanyaları ₺5.34-8.24 CPC bandında, engagement ₺4.10 CPC / ₺67 CPM).
                  <strong> Google Search, YouTube ve TikTok satırları tahminidir</strong> — bu hesaplarda hiç geçmiş harcama olmadığı için pazar
                  benchmark'ı kullanılmıştır (TikTok Video Views ₺25 CPM · ₺0.06 CPV). TikTok'ta trafik kampanyası yoktur. Erişim rakamları platform içi tekildir, mecralar arası çakışma ölçülemez.
                  <strong> Lead adedi ve lead başı maliyet projekte edilmemiştir</strong>: form dönüşüm oranı bugün ölçülmüyor, dolayısıyla tıklamadan
                  lead'e geçiş oranı bilinmiyor. İlk ayın önceliği bu metriğin ölçüme alınmasıdır; ölçüm kurulunca Eylül planı lead hedefiyle yazılabilir.
                  ⚠️ Meta bütçesi ₺50K'dan ₺41K'ya indiği için <strong>lead tıklaması ~%16 geriler</strong> (6,667 → 5,592) — bu bilinçli bir tercihtir.
                  TikTok ₺2,000 ile <strong>test seviyesindedir</strong>: bu bütçe kanalın çalışıp çalışmadığını gösterir, anlamlı hacim üretmez.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>
  );
}
